module.exports = __webpack_public_path__ + "img/icon_express.950da770.svg";